import { ColoursObj, Typography } from '@eventr/common-storybook'
import StarRateIcon from '@mui/icons-material/StarRate'
import { Box } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { useEphemeralStore } from '../../../state/useEphemeralStore'

/**
 * 1-5 starts, selectable
 */
export const StarRatingFilter: FC = () => {
    const { filtersObj, setFiltersObj } = useEphemeralStore(
        useShallow((s) => ({
            filtersObj: s.filtersObj,
            setFiltersObj: s.setFiltersObj,
        }))
    )

    const onSelect = (starRating: number) => {
        setFiltersObj({
            ...filtersObj,
            starRating: starRating,
        })
    }

    const starColour = (selected?: boolean) => {
        return selected ? ColoursObj.core.secondary : ColoursObj.core.primary
    }

    return (
        <Box display={'grid'} gap={'8px'}>
            <Typography variant="bodySubtext" color={ColoursObj.font.secondary}>
                {i18n.t('booking.starRating')}
            </Typography>

            <Box key={'starRating'} display={'grid'} gap={'8px'}>
                <Box
                    display={'grid'}
                    gridAutoFlow={'column'}
                    justifyItems={'center'}
                    padding={'8px 0'}
                >
                    {new Array(5).fill('star').map((_, index) => {
                        return (
                            <Box
                                key={index + 1}
                                display={'grid'}
                                onClick={() => {
                                    onSelect(index + 1)
                                }}
                            >
                                <StarRateIcon
                                    htmlColor={starColour(
                                        filtersObj.starRating >= index + 1
                                    )}
                                />
                            </Box>
                        )
                    })}
                </Box>
            </Box>
        </Box>
    )
}
